import { ManualInjector } from '../../../../../manual-injector';
import OrganizationService from '../../../../../../core/services/organization.service';
import _ from 'lodash';
export default class OrganizationSelect {
    static async load() {
        const orgService = ManualInjector.injector.get(OrganizationService);
        const orgs = await orgService.model.array;
        const componentData = _.transform(orgs, (memo, org, idx) => {
            memo[idx] = {
                label: org.name,
                value: org.id
            };
        });
        return {
            label: 'Organization',
            description: 'Select Organization',
            key: 'organizationSelect',
            type: 'select',
            multi: false,
            data: {
                values: componentData,
            },
            validate: {
                required: true
            }
        };
    }
}
